import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import account from './modules/account';
import adventures from './modules/adventures';
import applications from './modules/applications';
import backupCare from './modules/backupCare';
import interviewRequest from './modules/interviewRequest';
import job from './modules/job';
import messages from './modules/messages';
import navigation from './modules/navigation/index';
import sitterOnboarding from './modules/sitterOnboarding';
import { clearCache } from './cache';

Vue.use(Vuex);

clearCache();

const vuexSessionStorage = new VuexPersist({
  key: 'vuex', // display key in the browser session
  storage: window.sessionStorage,
  reducer(state: any) {
    return { sitterOnboarding: state.sitterOnboarding }; // only persist sitter onboarding state in session storage
  },
});

const store = new Vuex.Store({
  plugins: [vuexSessionStorage.plugin],
  modules: {
    account,
    adventures,
    applications,
    backupCare,
    interviewRequest,
    job,
    messages,
    navigation,
    sitterOnboarding,
  },
});

export default store;
